import PendoIcon from '../icon/pendo-icon.vue.js';

var script = {
  components: {
    PendoIcon
  },
  inject: ['$table'],
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  computed: {
    isAscending() {
      if (this.$table.sortStore.column) {
        return this.$table.sortStore.column.property === this.column.property && this.$table.sortStore.activeSort === 'ascending';
      }
      return false;
    },
    isDescending() {
      if (this.$table.sortStore.column) {
        return this.$table.sortStore.column.property === this.column.property && this.$table.sortStore.activeSort === 'descending';
      }
      return false;
    }
  }
};

export { script as default };
//# sourceMappingURL=sort-controls.vue2.js.map
